var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsNumber, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { OfficeProductResponseDto } from './office-product.response.dto.js';
export class OfficeProductAssignmentLineItemResponseDto {
    id;
    createdAt;
    updatedAt;
    officeProductAssignmentId;
    officeProductLineItemId;
    title;
    maxCount;
    currentCount;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentLineItemResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], OfficeProductAssignmentLineItemResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], OfficeProductAssignmentLineItemResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentLineItemResponseDto.prototype, "officeProductAssignmentId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentLineItemResponseDto.prototype, "officeProductLineItemId", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentLineItemResponseDto.prototype, "title", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeProductAssignmentLineItemResponseDto.prototype, "maxCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeProductAssignmentLineItemResponseDto.prototype, "currentCount", void 0);
export class OfficeProductAssignmentResponseDto {
    id;
    createdAt;
    updatedAt;
    officeProductId;
    patientId;
    connectedStripeAccountId;
    patientInvoiceId;
    applicationFeeInvoiceId;
    therameVideoCallsCount;
    therameExerciseProgramsCount;
    therameVideoCallsCompleted;
    therameVideoCallsReserved;
    therameExerciseProgramsCreated;
    totalRemainingTaskCount;
    startedAt;
    activeUntil;
    officeProductAssignmentLineItems;
    officeProduct;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], OfficeProductAssignmentResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], OfficeProductAssignmentResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentResponseDto.prototype, "officeProductId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentResponseDto.prototype, "patientId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentResponseDto.prototype, "connectedStripeAccountId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentResponseDto.prototype, "patientInvoiceId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentResponseDto.prototype, "applicationFeeInvoiceId", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentResponseDto.prototype, "therameVideoCallsCount", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentResponseDto.prototype, "therameExerciseProgramsCount", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentResponseDto.prototype, "therameVideoCallsCompleted", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentResponseDto.prototype, "therameVideoCallsReserved", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentResponseDto.prototype, "therameExerciseProgramsCreated", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeProductAssignmentResponseDto.prototype, "totalRemainingTaskCount", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentResponseDto.prototype, "startedAt", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentResponseDto.prototype, "activeUntil", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => OfficeProductAssignmentLineItemResponseDto),
    Expose(),
    __metadata("design:type", Array)
], OfficeProductAssignmentResponseDto.prototype, "officeProductAssignmentLineItems", void 0);
__decorate([
    ValidateNested(),
    Type(() => OfficeProductResponseDto),
    Expose(),
    __metadata("design:type", OfficeProductResponseDto)
], OfficeProductAssignmentResponseDto.prototype, "officeProduct", void 0);
//# sourceMappingURL=office-product-assignment.response.dto.js.map